import React from 'react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 py-12 border-t border-navy-800" data-id="element-87" data-mp="3gezf99jl213s">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88" data-mp="3ghc0pwojutll">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-89" data-mp="32p5mig4yiwos">
          <div className="flex items-center gap-3" data-id="element-90" data-mp="36qhhl16loa4d">
            <img src="https://cdn.magicpatterns.com/uploads/ryk41TLetQu6VxX6oqEWhT/FullLogo.png" alt="Universal Hockey Development" className="h-12 object-contain" data-id="element-91" data-mp="36n3axgqwler4" />
          </div>

          <nav className="flex flex-wrap justify-center gap-6 md:gap-8" data-id="element-92" data-mp="3lf58uv9exxoi">
            <a href="#mission" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-93" data-mp="3qdf7jfucjgev">
              About
            </a>
            <a href="#services" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-94" data-mp="2eya05yj9stox">
              Services
            </a>
            <a href="#team" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-95" data-mp="3lbdbmpwng3k8">
              Team
            </a>
            <a href="#network" className="text-sm font-medium text-slate-400 hover:text-white transition-colors" data-id="element-96" data-mp="3v5n7ihksvjzp">
              Network
            </a>
          </nav>
        </div>

        <div className="mt-8 pt-8 border-t border-navy-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-97" data-mp="33xcvurkbsqx">
          <p className="text-sm text-slate-500" data-id="element-98" data-mp="ht3ajear5awp">
            &copy; {currentYear} Universal Hockey Development. All rights
            reserved.
          </p>
          <div className="flex gap-4" data-id="element-99" data-mp="cw33b0262240">
            <a href="#" className="text-slate-500 hover:text-ice-500 transition-colors text-sm font-medium" data-id="element-100" data-mp="qsqdw5n1kqse">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-ice-500 transition-colors text-sm font-medium" data-id="element-101" data-mp="tvmnzb2xs4iq">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
};